

( function($) {
	var lastScroll = 0;
	$(window).on('scroll', function(){
		var currentScroll = $(this).scrollTop();
		
		if(currentScroll < lastScroll){
			$('#masthead').css('top', $('#topbar').height());

		}else{
			$('#masthead').css('top', '');
		}

		lastScroll = currentScroll;
	});

	$(document).ready(function(){
		$('.remove-qty,.add-qty').on('click',function(e){
			var quantity_input = $(this).siblings('input.qty');

			if($(this).hasClass('remove-qty')){
				if(quantity_input.val()>1){
					quantity_input.val(+(quantity_input.val())-1)
				}
			}else if($(this).hasClass('add-qty')){
				quantity_input.val(+(quantity_input.val())+1)
			}

			quantity_input.trigger('change');
		})
	})
	

    if($('.list-home-cat-wrapper').length){
		var slider = tns({
			container: '.wc-block-product-categories-list',
			autoplay:false,
			mouseDrag: true,
			speed:1000,
			animateDelay:1000,
			prevButton:document.getElementById('prev-nav'),
			nextButton:document.getElementById('next-nav'),
			nav : false,
			loop:false,
			items: 1,
			responsive: {
			  640: {
				gutter: 20,
				items: 2
			  },
			  700: {
				gutter: 30
			  },
			  1000: {
				items: 4
			  },

			}
		});
	}
	if($('.list-home-sale-wrapper').length){
		var slider = tns({
			container: '.wc-block-grid__products',
			autoplay:false,
			mouseDrag: true,
			speed:1000,
			animateDelay:1000,
			prevButton:document.getElementById('prev-nav-sale'),
			nextButton:document.getElementById('next-nav-sale'),
			nav : false,
			loop:false,
			items: 1,
			responsive: {
			  640: {
				gutter: 20,
				items: 2
			  },
			  700: {
				gutter: 30
			  },
			  1000: {
				items: 4
			  },

			}
		});
	}

	if($('.up-sells').length){
		var slider = tns({
			container: '.up-sells .products',
			autoplay:false,
			mouseDrag: true,
			speed:1000,
			animateDelay:1000,
			prevButton:document.getElementById('upsell-prev-nav'),
			nextButton:document.getElementById('upsell-next-nav'),
			nav : false,
			loop:false,
			items: 1,
			responsive: {
			  640: {
				gutter: 20,
				items: 2
			  },
			  700: {
				gutter: 30
			  },
			  1000: {
				items: 4
			  },

			}
		});
	}

	if($('#secondary').length){
		$('#secondary .widget ul li > a').click(function(e){
			e.preventDefault();

			var parent = $(this).parent();

			if(parent.hasClass('chosen')){
				parent.removeClass('chosen');

			}else{
				parent.addClass('chosen');
			}

			ajax_filter_products();
		});

		$('#secondary .reset-filters').click(function(e){
			e.preventDefault();

			$(this).parent().find('.chosen').removeClass('chosen');
			
			ajax_filter_products();
		});
	}

	if($('.loadmore').length){
		$('.loadmore').click(function(e){
			e.preventDefault();

			ajax_filter_products(true);
		});
	}

	var latestRequest = null;
	function ajax_filter_products(append){
		append = append == undefined ? false : append;

		var data = {
			ajax: true,
			action: 'theme_client_ajax_woo_cat_filter'
		}

		if(theme_client_data.order_by){
			data.orderby = theme_client_data.order_by;
		}

		var catIDs = ''; // String des catégories active pour le filtre.

		if(append){
			data['currentCount'] = $('.shop-products-wrapper .products > .product').length;
			
			$('.show-more-products').addClass('loading-more');

		}else{
			$('.shop-products-wrapper').addClass('loading');
		}

		if(theme_client_data.current_product_cat){
			catIDs = theme_client_data.current_product_cat;
		}

		if($('.widget_product_categories').length && $('.widget_product_categories').find('.chosen').length){
			catIDs = ''; // On retire la catégorie par défaut, on veux afficher des sous filtres.

			$('.widget_product_categories').find('.chosen').each(function(elem){
				this.classList.forEach(function(className){
					if(className.indexOf('cat-item-') !== -1){
						catIDs += className.replace('cat-item-', '')+',';

						return true;
					}
				});
			});
		}

		if(catIDs != ''){
			data.catIDs = catIDs;
		}

		if($('.woocommerce-widget-layered-nav').length){
			var attributes = [];

			$('.woocommerce-widget-layered-nav').each(function(){
				if($(this).find('.chosen').length){
					var generalVars = new URL($(this).find('.chosen > a').attr('href'));
					
					var attributeName = '';

					for(var key of generalVars.searchParams.keys()) { 
						if(key.indexOf('filter_') !== -1){
							attributeName = key.replace('filter_', '');
							break;
						}
					}

					var termSlugs = '';
					var queryType = generalVars.searchParams.get('query_type_'+attributeName);
					
					$(this).find('.chosen > a').each(function(elem){
						var termURL = new URL($(this).attr('href'));
						termSlugs += termURL.searchParams.get('filter_'+attributeName)+',';
					});

					attributes.push({
						name: attributeName,
						queryType: queryType,
						termSlugs: termSlugs
					});
				}
			});

			data.attributes = attributes;
		}

		latestRequest = $.post( theme_client_data.ajax_url, data, function(res, status, jqXHR){
			JSON.stringify(res);
			if(latestRequest === jqXHR){

				if(!append){
					$('.shop-products-wrapper .products').empty();
				}

				if((res.count + $('.shop-products-wrapper .products > .product').length) >= res.total){
					$('.loadmore').hide();

				}else{
					$('.loadmore').show();
				}
				
				$('.shop-products-wrapper .products').append(res.html).removeClass('loading');
				$('.shop-products-wrapper').removeClass('loading');
				$('.show-more-products').removeClass('loading-more');
			}
		}, 'json');
	}

	$('select#billing_team, select#billing_pickup_branch').selectWoo();

} )(jQuery);

